import { useMutation } from '@tanstack/react-query';
import {
  getNotifications,
  IGetNotificationsParams,
  markSeenNotifications,
} from '../queries/Menu';
import { useNotificationsStore } from '../stores/useNotifications';

export function notificationsHook(params: IGetNotificationsParams) {
  const { setNotifications } = useNotificationsStore();

  const { mutate, data, isPending } = useMutation({
    mutationKey: ['notifications', params],
    mutationFn: (params: IGetNotificationsParams) => getNotifications(params),
    onSuccess: (data) => {
      setNotifications(data);
    },
    retry: false,
  });

  return {
    mutate,
    data,
    isPending,
  };
}

export function seenNotificationsHook() {
  const { setHasNotificationPendindg } = useNotificationsStore();

  const { mutate } = useMutation({
    mutationKey: ['notifications-seen'],
    mutationFn: () => markSeenNotifications(),
    onSuccess: () => {
      setHasNotificationPendindg();
    },
    retry: false,
  });

  return {
    mutateSeen: mutate,
  };
}
